// extracted by mini-css-extract-plugin
module.exports = {"buttonInner":"TextInput_buttonInner__DFS6z","container":"TextInput_container__Buemu","permaPlaceholder":"TextInput_permaPlaceholder__kl23L"};